import firebase from 'firebase'
import 'firebase/auth'
import 'firebase/firestore'

// firebase init
const firebaseConfig = {
  apiKey: 'AIzaSyAwBj03xZLUjMIPYHY4cFQReXgFCbOwB30',
  authDomain: 'minutiae-e8fa2.firebaseapp.com',
  databaseURL: 'https://minutiae-e8fa2.firebaseio.com',
  projectId: 'minutiae-e8fa2',
  storageBucket: 'minutiae-e8fa2.appspot.com',
  messagingSenderId: '613777997880',
  appId: '1:613777997880:web:d5d6a973cd8b77ea6ee6cd'
}

firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()
firebase.auth().languageCode = 'fr'

// collection references
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')

// export utils/refs
export {
  db,
  auth,
  storage,
  usersCollection,
  postsCollection
}



// WEBPACK FOOTER //
// ./src/firebase.js